<template>
  <div>
    <v-layout wrap justify-center align-center>
      <v-flex xs8>
        <v-progress-circular :size="size" :width="width" :value="porcentaje" :rotate="rotate" :color="color">
          {{ porcent }}%
        </v-progress-circular>

      </v-flex>
      <v-flex>
        <v-btn flat icon color="green" @click="set('+')">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn flat icon color="red" @click="set('-')">
          <v-icon>remove</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <p>{{ txt[porcent] }}</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: "Probabilidad",
  props: ['size', 'width', 'porcentaje', 'rotate', 'presupuesto'],
  data() {
    return {
      txt: {
        0: '',
        20: 'Presupuesto Emitido',
        40: 'En negociación',
        60: 'Negociación avanzada o anticipada sin definición de producto. (No apto para planificación)',
        80: '(Pre aprobado) Negociación avanzada con definición de producto pero no de medidas. No necesariamente anticipada. (Apto para planificación)',
        100: 'Operación confirmada',
        120: '(Acopio) Cliente pagó de manera anticipada pero no definió medidas'
      }
    }
  },
  computed: {
    porcent() {
      return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.porcentaje);
    },
    color() {
      let hue = (this.porcentaje * 120).toString(10);
      return ["hsl(", hue, ",100%,40%)"].join("");
    }
  },
  methods: {
    ...mapActions('notif', ['msjShow']),
    set(oper) {
      if (oper === '+') {
        this.porcentaje = (this.porcentaje === 120) ? 0 : this.porcentaje + 20;
      } else {
        this.porcentaje = (this.porcentaje === 0) ? 0 : this.porcentaje - 20;
      }
      this.$http.post('/presupuesto/probabilidad-set', {
        'presupuesto_id': this.presupuesto,
        'probabilidad': this.porcentaje
      }).then(r => this.msjShow(r.data))
          .catch(err => this.msjShow({tipo: 2, txt: 'Error en guardado'}))
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Probabilidad.vue